// AR
export const calendarHotel = {
  btn: {
    today: "اليوم",
  },
  summary: {
    availableLabel: "متاح",
  },
  tooltip: {
    closed: "مغلق",
    dragToCreate: "اسحب للتحديد (إنشاء حجز)",
  },
  labels: {
    room: "غرفة",
    rooms: "غرف",
    number: "الرقم:",
    capacityIconAlt: "السعة",
    maintenanceBadge: "صيانة",
  },
  toasts: {
    reservationCreatedOk: "تم إنشاء الحجز بنجاح.",
    reservationCreateErrPrefix: "تعذّر إنشاء الحجز: ",
    roomChangedOk: "تم تغيير الغرفة بنجاح",
    roomChangedErr: "خطأ في تغيير الغرفة",
    roomTypeChangedOk: "تم نقل الحجز إلى {type}",
  },
  warn: {
    selectTwoDays: "اختر يومين على الأقل (تسجيل الوصول وتسجيل المغادرة).",
  },
  errors: {
    closedForBooking: "لا يمكنك حجز غرفة/فترة مغلقة.",
    noAvailabilityTitle: "لا يوجد توفّر",
    noAvailabilityDetail: "لا توجد غرف متاحة لهذا النوع في تلك التواريخ.",
    noRatesTitle: "لا توجد أسعار مُعيَّنة",
    noRatesDetail: "لا توجد أسعار متاحة لهذا النوع في تلك التواريخ.",
    missingDataTitle: "بيانات ناقصة",
    missingDataDetail: "يرجى ملء جميع الحقول المطلوبة.",
  },
  maintenanceModal: {
    titleFallback: "الغرفة",
    statusSection: "الحالة",
    closeForMaintenance: "إغلاق للصيانة",
    open: "مفتوح",
    hint:
      "عندما تكون الغرفة قيد الصيانة، لا يمكن بيعها وستظهر خلاياها باللون الأحمر. تُحترم الحجوزات الحالية.",
    actions: {
      cancel: "إلغاء",
      save: "حفظ",
      saving: "جارٍ الحفظ…",
    },
  },

  // ===== NEW: Reservation modal =====
  modal: {
    title: "تسجيل حجز جديد",
    startDate: "تسجيل الوصول",
    endDate: "تسجيل المغادرة",
    roomType: "نوع الغرفة",
    roomTypePlaceholder: "اختر النوع",
    quantity: "عدد الغرف",
    available: "متاح",
    guestName: "الضيف المسؤول",
    guestNamePlaceholder: "الشخص المسؤول عن الحجز",
    guests: "عدد الضيوف",
    guestsPlaceholder: "عدد الضيوف",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    notes: "ملاحظة",
    notesPlaceholder: "ملاحظات داخلية للحجز (مثل الوصول المتأخر، سرير أطفال، حساسية…)",
    addType: "إضافة نوع غرفة آخر",
    price: "السعر",
    pricePlaceholder: "أدخل السعر",
    cancel: "إلغاء",
    create: "إنشاء حجز",
  },

  // ===== Validations =====
  validation: {
    minGuestsTitle: "عدد الضيوف غير كافٍ",
    minGuestsDetail: "يجب أن يكون هناك {min} ضيف على الأقل لعدد {rooms} غرفة.",
    maxGuestsTitle: "تم تجاوز حد الضيوف",
    maxGuestsDetail: "الحد الأقصى {maxPerRoom} ضيوف لكل غرفة ({maxTotal} إجمالاً لعدد {rooms} غرف).",
    maxRoomsTitle: "تم تجاوز الحد",
    maxRoomsDetail: "لا يمكنك حجز أكثر من {max} غرف.",
  },

  // ===== Promotions & Taxes =====
  promotions: {
    limitTitle: "تم بلوغ الحد",
    limitDetail: "لا يمكنك إضافة أكثر من عرض ترويجي واحد.",
  },
  taxes: {
    limitTitle: "تم بلوغ الحد",
    limitDetail: "لا يمكنك إضافة أكثر من ضريبة واحدة.",
  },
};
